import { render, staticRenderFns } from "./existingfiles.vue?vue&type=template&id=58bc8f2b"
import script from "./existingfiles.vue?vue&type=script&lang=ts"
export * from "./existingfiles.vue?vue&type=script&lang=ts"
import style0 from "./existingfiles.vue?vue&type=style&index=0&id=58bc8f2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports